
import ProjectControlFinanceRound from '~/components/project/ProjectControlFinanceRound'
import ProjectControlOpenRound from '~/components/project/ProjectControlOpenRound'
import ProjectControlInactive from '~/components/project/ProjectControlInactive'
import ProjectProgressBar from '~/components/project/ProjectProgressBar'
import VFormGroup from '~/components/ui/VFormGroup'
import VCheckbox from '~/components/ui/VCheckbox'
import VButton from '~/components/ui/VButton'
import { mapState, mapGetters } from 'vuex'

export default {
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState('profile', [
            'currentAccount'
        ]),
        ...mapGetters('profile', [
            'role'
        ]),
    },
    methods: {
        
    },
    components: {
        ProjectControlFinanceRound,
        ProjectControlOpenRound,
        ProjectControlInactive,
        ProjectProgressBar,
        VFormGroup,
        VCheckbox,
        VButton
    }
}
